import React, { Component } from 'react';
import Logo from 'components/logo/logo.component';
import { HamburgerButton } from 'react-hamburger-button';

import {
  StyledWrapper,
  StyledLogo,
  StyledNav,
  StyledNavList,
  StyledNavItem,
  StyledNavLink,
  StyledMenuButton,
} from "./header.style";

import { StyledElementWrapperCenter } from 'styledElements';

// Texts
import text from 'i18l';


class Header extends Component {

  state = {
    isDocking: false,
    isOpened: false
  };

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  };

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  };

  handleScroll = () => {
    const { isDocking, isOpened } = this.state;

    if ( window.scrollY > 500 && isDocking === false && !isOpened) {
      this.setState({isDocking: true});
    } else if (window.scrollY <= 500 && isDocking === true && !isOpened) {
      this.setState({isDocking: false});
    }
  };

  handleOpenMenu = () => this.setState((prevState) => ({isOpened:!prevState.isOpened}));

  renderNavItems = () => text.NAV.map((navItem) =>
    <StyledNavItem key={navItem.key}>
      <StyledNavLink to={navItem.url} activeClassName="active" onClick={this.handleOpenMenu} className="navLink">
        {navItem.name}
      </StyledNavLink>
    </StyledNavItem>
  );

  render() {
    const { isDocking, isOpened } = this.state;
    return (
      <StyledWrapper isDocking={isDocking}>
        <StyledElementWrapperCenter>
          <StyledLogo isDocking={isDocking}>
            <Logo/>
          </StyledLogo>
          <StyledMenuButton
            isDocking={isDocking}
          >
            <HamburgerButton
              open={isOpened}
              onClick={this.handleOpenMenu}
              width={40}
              height={20}
              strokeWidth={2}
              color='white'
              animationDuration={0.5}
            />
          </StyledMenuButton>
          <StyledNav
            isOpened={isOpened}
          >
            <StyledNavList isDocking={isDocking}>
              {this.renderNavItems()}
            </StyledNavList>
          </StyledNav>
        </StyledElementWrapperCenter>
      </StyledWrapper>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/header/header.component.js